import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { processSeoVariables } from '@iheartjane/utils';

export function title(...parts: (string | undefined)[]) {
  return {
    title: parts.filter(Boolean).join(' | ') || 'Jane Premium',
  };
}

export function getMetaTitle(
  customSEOPage?: Nullish<CustomSEOPage>,
  metaVariables: Record<string, string> = {}
) {
  return title(processSeoVariables(customSEOPage?.title, metaVariables));
}
